export default __webpack_public_path__ + "static/media/sticker-promo-mx.589743be.png";